import React from 'react';
import './NoResults.css';

const NoResults = ({ location }) => {
  return (
    <div className="no-results">
      <div className="no-results-content">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
            stroke="currentColor" strokeWidth="2"/>
          <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
        </svg>
        <h3>No venues found within 50 miles</h3>
        <p>Try searching for a specific city or venue name instead.</p>
        {location && location.toLowerCase() === 'current location' && (
          <div className="location-help">
            <p><strong>Location Access Issue:</strong></p>
            <p>Your browser blocked location access. Here's how to fix it:</p>
            <ul>
              <li>Click the lock/shield icon in your address bar</li>
              <li>Select "Allow" for location access</li>
              <li>Refresh the page and try again</li>
            </ul>
            <p><strong>Alternative:</strong> Search for "Austin" instead to see Austin venues.</p>
            <button 
              onClick={() => {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    alert(`Your location: ${position.coords.latitude}, ${position.coords.longitude}`);
                  },
                  (error) => {
                    if (error.code === 1) {
                      alert('Location permission denied. Please enable location access in your browser settings.');
                    } else {
                      alert(`Location error: ${error.message}`);
                    }
                  }
                );
              }}
              className="test-location-btn"
            >
              Test Location Access
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoResults;

